function deepFreezeDescendants(obj) {
  Object.seal(obj);
  Object.getOwnPropertyNames(obj).forEach((prop) => deepFreeze(obj[prop]));
  return obj;
}
function deepFreeze(obj) {
  if (obj && typeof obj === "object" && !Object.isFrozen(obj)) {
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach((prop) => deepFreeze(obj[prop]));
  }
  return obj;
}
export {
  deepFreeze,
  deepFreezeDescendants
};
//# sourceMappingURL=deepFreeze.js.map
